module.exports = __webpack_public_path__ + "static/CategoryIcons2-235513e39b57e4a9f00f7e892b5975e6.svg";